import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const isAuthEndpoint =
    req.url.includes('/auth/login') || req.url.includes('/auth/register');

  // Clone request and add auth header if token exists
  const clonedReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    : req;

  // Handle the request and catch auth errors
  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Only force logout on explicit authentication failures.
      // Do NOT auto-logout on generic 403 business-rule/authorization responses.
      const backendMessage = String(error.error?.error || '').toLowerCase();
      const isExplicitAuthFailure =
        backendMessage.includes('invalid or expired token') ||
        backendMessage.includes('authentication token required');

      if (
        (error.status === 401 || (error.status === 403 && isExplicitAuthFailure)) &&
        !!token &&
        !isAuthEndpoint
      ) {
        console.log('🔒 Authentication error detected - logging out user');
        authService.logout();
      }

      return throwError(() => error);
    })
  );
};
